/**
 * 观测天数设置组件
 */
import React, { useState, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { useIntl } from 'umi';
import { Bubble } from 'tea-component';
import { IObservationSettingsProps } from './types';
import './index.scss';

const ObservationSettings: React.FC<IObservationSettingsProps> = (props) => {
  const { formatMessage } = useIntl();
  const {
    className,
    title,
    required,
    value: propsValue,
    onChange,
    min = 1,
    max = 30,
  } = props || {};
  // 输入框展示值（可为空字符串），失焦时恢复为有效数字
  const [inputValue, setInputValue] = useState<string>(String(propsValue));

  // 同步外部传入的 value 到内部展示
  useEffect(() => {
    setInputValue(String(propsValue));
  }, [propsValue]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (['e', 'E', '+', '-', '.'].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value: raw } = e.target;
    // 允许输入为空，仅更新展示
    setInputValue(raw);
    if (raw === '') return;
    const numValue = Number(raw);
    if (!Number.isNaN(numValue) && Number.isInteger(numValue) && numValue >= min && numValue <= max) {
      onChange(numValue);
    }
  };

  const handleBlur = (): void => {
    const trimmed = inputValue.trim();
    if (trimmed === '') {
      setInputValue(String(min));
      onChange(min);
      return;
    }
    const numValue = Number(trimmed);
    if (Number.isNaN(numValue) || !Number.isInteger(numValue) || numValue < min) {
      setInputValue(String(min));
      onChange(min);
      return;
    }
    if (numValue > max) {
      setInputValue(String(max));
      onChange(max);
      return;
    }
    setInputValue(String(numValue));
    onChange(numValue);
  };

  const exceedsMax = useMemo(() => {
    const trimmed = inputValue.trim();
    if (trimmed === '') return false;
    const num = Number(trimmed);
    return !Number.isNaN(num) && Number.isInteger(num) && num > max;
  }, [inputValue, max]);

  return (
    <div className={classNames('dbl-observation-settings', className)}>
      {title && <div className={classNames("dbl-observation-settings-title", { "is-required": required })}>{title}</div>}
      <Bubble
        error
        visible={exceedsMax}
        placement="top"
        content={formatMessage(
          { id: 'dbl_ab_experiment_observation_days_exceeds_max' },
          { max }
        )}
      >
        <input
          type="number"
          className="dbl-observation-settings-input"
          value={inputValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          min={min}
          max={max}
          step={1}
          required={required}
        />
      </Bubble>
    </div>
  );
};

export default ObservationSettings;
